import { combineReducers } from 'redux';
import formReducer from './form';
import customersReducer from './customers';
import sitesReducer from './sites';

export default combineReducers({
  form: formReducer,
  customers: customersReducer,
  sites: sitesReducer,
});



// WEBPACK FOOTER //
// ./src/modules/saas/aast/common/modals/case-transfer/reducers/index.js